import {LocationMiscellaneousCertificationModel} from './location-miscellaneous-certification.model';

export class JunctionBoxDetailModel {
    id?: string | null = null;
    name?: string | null = null;
    fieldAssociatedApparatus?: string | null = null;
    supplier?: string | null = null;
    serialNo?: string | null = null;
    installedDate?: Date | null = null;
    classification?: string | null = null;
    manufacturer?: string | null = null;
    modelNo?: string | null = null;
    divisionForRiskLevel?: string | null = null;

    // Certification related properties
    certificationScheme?: string | null = null;
    certificationNumber?: string | null = null;
    lowAmbientTemperature?: string | null = null;
    highAmbientTemperature?: string | null = null;
    lowServiceTemperature?: string | null = null;
    highServiceTemperature?: string | null = null;
    combinationOptionGas?: string | null = null;
    inspectionFrequency?: string | null = null;
    protectionTechniqueGas?: string[] | null = null;
    protectionTechniqueEplGas?: string[] | null = null;
    protectionTechniqueDust?: string[] | null = null;
    protectionTechniqueEplDust?: string[] | null = null;
    eplGas?: string | null = null;
    gasGroup?: string | null = null;
    eplDust?: string | null = null;
    dustGroup?: string | null = null;
    gasTempClass?: string | null = null;
    maximumSurfaceTemperature?: string | null = null;
    testingDustLayerDepth?: string | null = null;
    maximumSurfaceTemperatureWithDustLayer?: string | null = null;
    ipx?: string | null = null;
    ipy?: string[] | null = null;

    note?: string | null = null;

    miscellaneousCertification?: LocationMiscellaneousCertificationModel | null = null;

    created?: Date | null = null;
    updated?: Date | null = null;

    locationId?: string | null = null;

    constructor(data?: Partial<JunctionBoxDetailModel>) {
        Object.assign(this, data);
        if (!this.miscellaneousCertification) {
            this.miscellaneousCertification = new LocationMiscellaneousCertificationModel();
        }
    }
}
